import DiscountTypeAddPage from './DiscountTypeAddPage';

export default DiscountTypeAddPage;
